import React from "react"
import { Box, Divider, Flex, Heading, HStack, Text } from "@chakra-ui/react"
import dayjs from "dayjs"

export class Receipt extends React.Component {
  render() {
    return (
      <Flex
        // bg="brandColor"
        w="100%"
        h="100%"
        direction={"column"}
        justify="flex-start"
        align="flex-start"
      >
        <Flex
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          w="100%"
          bg="#fff"
          shadow="xl"
          // pb={8}
          borderRadius={5}
        >
          <HStack
            justifyContent="space-between"
            bg="#4D8ADF"
            borderRadius={5}
            fontSize="1rem"
            fontFamily="Montserrat"
            fontWeight="bold"
            p={3}
            px="0 !mportant"
            w="100%"
          >
            <Text color="#8DFF8D">
              {this?.props?.userProfile?.streetId?.estateId?.estateName}
            </Text>
            <Text color="gray.800" fontSize="1.4rem">
              User
            </Text>
          </HStack>
          {/* <Avatar
            my={3}
            boxSize="150px"
            borderRadius="5px"
            name={"this.props.visitorBadge?.fullName"}
            src={"this.props.visitorBadge?.imageURL"}
          /> */}
        </Flex>
        <Box shadow="xl" p="20px" width="100%">
          <Flex width={"100%"} justifyContent="flex-end">
            <Text>{dayjs().format("D, MMM YYYY")}</Text>
            <Text ml="10px">{dayjs().format("hh:mm a")}</Text>
          </Flex>
          <Heading color="gray.800" mb="10px">
            Invoice to:
          </Heading>
          <Text>
            <b>Host:</b> {this.props?.userProfile?.name}
          </Text>
          <Text>
            <b>Address:</b> {this.props?.userProfile?.houseId?.houseNumber}
          </Text>
          <Text>
            <b>Phone Number:</b> {this.props?.userProfile?.phoneNumber}
          </Text>

          <Text>
            <b>Payment Method:</b> Received
          </Text>
          <Divider my="10px" />
          <Text fontSize={"20px"} fontWeight={"bold"}>
            Utility
          </Text>
          <Text textTransform={"capitalize"}>
            Utility Type: {this.props.utilityType}
          </Text>
          <Text>Amount: {this.props.amountPaid || this.props.amountCal}</Text>
          <Text>Quantity:{this.props.unit || this.props.unitPurchased} </Text>
        </Box>
      </Flex>
    )
  }
}
